(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class FooterYoutubeBg extends HTMLElement {
    /** @type {YT.Player | undefined} */
    #player;
    /** @type {ReturnType<typeof setInterval> | undefined} */
    #watchId;

    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.matchMedia('(max-width: 749px)').matches) {
        const footer = this.closest('.footer-brand');
        if (footer?.querySelector('.footer-brand__media--gif') || footer?.classList.contains('footer-brand--hide-video-mobile')) {
          return;
        }
      }

      const videoId = this.dataset.videoId;
      if (!videoId) return;

      this.#loadApi().then(() => this.#initPlayer(videoId));
    }

    disconnectedCallback() {
      if (this.#watchId) clearInterval(this.#watchId);
      this.#player?.destroy?.();
    }

    /** @returns {Promise<void>} */
    #loadApi() {
      return new Promise((resolve) => {
        if (window.YT?.Player) {
          resolve();
          return;
        }

        const previous = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = () => {
          if (typeof previous === 'function') previous();
          resolve();
        };

        if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          document.head.appendChild(tag);
        }
      });
    }

    /** @param {string} videoId */
    #initPlayer(videoId) {
      const host = document.createElement('div');
      this.appendChild(host);

      this.#player = new YT.Player(host, {
        videoId,
        playerVars: {
          autoplay: 1,
          mute: 1,
          controls: 0,
          disablekb: 1,
          fs: 0,
          iv_load_policy: 3,
          cc_load_policy: 0,
          modestbranding: 1,
          playsinline: 1,
          rel: 0,
        },
        events: {
          onReady: (event) => {
            event.target.mute();
            event.target.playVideo();
            this.#startWatch();
          },
          onStateChange: (event) => {
            // Avoid native loop chrome: restart before/at end ourselves
            if (event.data === YT.PlayerState.ENDED) {
              event.target.seekTo(0, true);
              event.target.playVideo();
            }
          },
        },
      });
    }

    #startWatch() {
      this.#watchId = setInterval(() => {
        const player = this.#player;
        if (!player?.getDuration || !player?.getCurrentTime) return;

        const duration = player.getDuration();
        const current = player.getCurrentTime();
        if (duration > 0 && duration - current <= 0.6) {
          player.seekTo(0, true);
          player.playVideo();
        }
      }, 200);
    }
  }

  if (!customElements.get('footer-youtube-bg')) {
    customElements.define('footer-youtube-bg', FooterYoutubeBg);
  }

  const bindFooterNewsletter = () => {
    const form = document.getElementById('FooterNewsletter');
    if (!form || form.dataset.ajaxBound === 'true') return;

    form.dataset.ajaxBound = 'true';

    const input = form.querySelector('#FooterNewsletter-email');
    const button = form.querySelector('.footer-brand__newsletter-submit');
    const success = form.querySelector('#FooterNewsletter-success');
    const error = form.querySelector('#FooterNewsletter-error');

    const hide = (el) => {
      if (!el) return;
      el.hidden = true;
    };

    const show = (el, text) => {
      if (!el) return;
      if (typeof text === 'string' && text !== '') el.textContent = text;
      el.hidden = false;
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      hide(success);
      hide(error);
      input?.removeAttribute('aria-invalid');

      if (button) button.disabled = true;

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/javascript' },
        });

        if (!response.ok) throw new Error('Request failed');

        if (input) {
          input.value = '';
          input.setAttribute('aria-describedby', 'FooterNewsletter-success');
        }
        show(success);
      } catch {
        if (input) {
          input.setAttribute('aria-invalid', 'true');
          input.setAttribute('aria-describedby', 'FooterNewsletter-error');
        }
        show(error, error?.dataset.defaultError || 'Please enter a valid email.');
      } finally {
        if (button) button.disabled = false;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFooterNewsletter);
  } else {
    bindFooterNewsletter();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
